import React, { Component } from 'react';

import Test from './components/Test/index';

var TestList = React.createClass({
  render: function(){
    return(
      <div className="UserList">
        {this.props.specialties ? this.props.specialties.map((x, i) => {
          if(x.test){
            return(
              <Test
                key={i}
                specialty={x}
                handlerReloadSpecialties={this.props.handlerReloadSpecialties}
                login={this.props.login}
                pass={this.props.pass}
                specialties={this.props.specialties}
              />
            );
          }else{
            return null;
          }
          
        }) : null}
      </div>
    );
  }
});

export default TestList;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/TestList/index.jsx
 **/